import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { NAV } from "@/lib/content";
import { Menu, X } from "lucide-react";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === "/";
  const nh = (h) => (onHome ? h : `/${h}`);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-background/80 border-b border-border py-4"
          : "py-6 bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-serif text-xl md:text-2xl tracking-tight leading-none"
        >
          Dr. Joanne Hill Powell
          <span className="block text-[10px] uppercase tracking-[0.3em] text-muted-foreground mt-1 font-sans">
            Ascending Trends
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={nh(n.href)}
              data-testid={`nav-${n.href.replace("#", "")}`}
              className="text-sm text-foreground/70 hover:text-primary transition-colors duration-300 relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href={nh("#labs")}
            data-testid="nav-cta"
            className="rounded-full bg-primary px-6 py-3 text-xs uppercase tracking-[0.18em] font-medium text-primary-foreground transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_30px_-12px_rgba(193,119,103,0.6)]"
          >
            Register for Fall Cohort
          </a>
        </nav>

        <button
          className="md:hidden"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden backdrop-blur-xl bg-background/95 border-t border-border mt-4">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={nh(n.href)}
                onClick={() => setOpen(false)}
                className="text-lg font-serif"
              >
                {n.label}
              </a>
            ))}
            <a
              href={nh("#labs")}
              onClick={() => setOpen(false)}
              className="rounded-full bg-primary px-6 py-3 text-xs uppercase tracking-[0.18em] font-medium text-primary-foreground text-center"
            >
              Register for Fall Cohort
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
